// Check if we're in a browser environment (not Node.js during build)
const isBrowser = () => {
  try {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
  } catch {
    return false
  }
}

const getTokenLocalStorage = () => {
  if (!isBrowser()) {
    return null
  }
  try {
    return window.localStorage.getItem('token')
  } catch {
    return null
  }
}

const putTokenLocalStorage = (id: string) => {
  if (!isBrowser()) {
    return
  }
  try {
    window.localStorage.setItem('token', id)
  } catch {
    // Ignore errors
  }
}

const removeTokenLocalStorage = () => {
  if (!isBrowser()) {
    return
  }
  try {
    window.localStorage.removeItem('token')
  } catch {
    // Ignore errors
  }
}

const getAdminTokenLocalStorage = () => {
  if (!isBrowser()) {
    return null
  }
  try {
    return window.localStorage.getItem('adminToken')
  } catch {
    return null
  }
}

const putAdminTokenLocalStorage = (id: string) => {
  if (!isBrowser()) {
    return
  }
  try {
    window.localStorage.setItem('adminToken', id)
  } catch {
    // Ignore errors
  }
}

const removeAdminTokenLocalStorage = () => {
  if (!isBrowser()) {
    return
  }
  try {
    window.localStorage.removeItem('adminToken')
  } catch {
    // Ignore errors
  }
}

const getInviteHashLocalStorage = () => {
  if (!isBrowser()) {
    return null
  }
  try {
    return window.localStorage.getItem('inviteHash')
  } catch {
    return null
  }
}

const putInviteHashLocalStorage = (inviteHash: string) => {
  if (!isBrowser()) {
    return
  }
  try {
    window.localStorage.setItem('inviteHash', inviteHash)
  } catch {
    // Ignore errors
  }
}

const removeInviteHashLocalStorage = () => {
  if (!isBrowser()) {
    return
  }
  try {
    window.localStorage.removeItem('inviteHash')
  } catch {
    // Ignore errors
  }
}

const getStudentFormValuesLocalStorage = (hashedHetu: string) => {
  if (!isBrowser()) {
    return null
  }
  try {
    return window.localStorage.getItem('studentFormValues_' + hashedHetu)
  } catch {
    return null
  }
}

const putStudentFormValuesLocalStorage = (hashedHetu: string, formValues: any) => {
  if (!isBrowser()) {
    return
  }
  try {
    window.localStorage.setItem('studentFormValues_' + hashedHetu, formValues)
  } catch {
    // Ignore errors
  }
}

const removeStudentFormValuesLocalStorage = (hashedHetu: string) => {
  if (!isBrowser()) {
    return
  }
  try {
    window.localStorage.removeItem('studentFormValues_' + hashedHetu)
  } catch {
    // Ignore errors
  }
}

export {
  getTokenLocalStorage,
  putTokenLocalStorage,
  removeTokenLocalStorage,
  getAdminTokenLocalStorage,
  putAdminTokenLocalStorage,
  removeAdminTokenLocalStorage,
  getInviteHashLocalStorage,
  putInviteHashLocalStorage,
  removeInviteHashLocalStorage,
  getStudentFormValuesLocalStorage,
  putStudentFormValuesLocalStorage,
  removeStudentFormValuesLocalStorage
}
